export default __webpack_public_path__ + "static/media/trophy_black.9d35e1e0.svg";